import {useEffect,useState} from 'react';
const uuid=/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
export function StaffGiftCardPayment({location,customerId,ticketKey,
  reservationIds,eligible,onComplete}:{location:string;customerId:string|null;
  ticketKey:string;reservationIds:string[];eligible:boolean;onComplete:()=>void}){
  const [busy,setBusy]=useState(false);
  const [giftDraftId,setGiftDraftId]=useState<string|null>(null);
  const [status,setStatus]=useState('');
  const [error,setError]=useState('');
  const reservationSignature=reservationIds.join(',');
  useEffect(()=>{
    setGiftDraftId(null);setStatus('');setError('');setBusy(false);
  },[ticketKey,customerId,location,reservationSignature]);
  useEffect(()=>{
    if(!giftDraftId||!customerId||status==='ISSUED_PENDING_DELIVERY')return;
    let active=true;
    const poll=async()=>{
      try{
        const response=await fetch('/api/v1/staff/sales/stripe/test-gift-drafts/'+
          encodeURIComponent(giftDraftId)+'?'+new URLSearchParams({
            location,customerId,
          }),{credentials:'same-origin',cache:'no-store'});
        const body=await response.json() as {ok:boolean;data?:{
          status:string;paid:boolean;voucherCount:number}};
        if(active&&response.ok&&body.ok&&body.data){
          if(body.data.status==='ISSUED_PENDING_DELIVERY'&&
            body.data.paid&&body.data.voucherCount===reservationIds.length)
            setStatus('ISSUED_PENDING_DELIVERY');
          else if(body.data.paid)setStatus('PAID_UNFULFILLED');
        }
      }catch{/* Stripe return is never proof of a paid Gift Card. */}
    };
    void poll();const timer=window.setInterval(()=>void poll(),3000);
    return ()=>{active=false;window.clearInterval(timer);};
  },[giftDraftId,customerId,location,status,reservationIds.length]);
  const checkout=async()=>{
    if(!eligible||!customerId||busy||!uuid.test(ticketKey))return;
    const tab=window.open('about:blank','_blank');
    setBusy(true);setError('');
    try{
      const response=await fetch('/api/v1/staff/sales/stripe/test-gift-checkout',{
        method:'POST',credentials:'same-origin',cache:'no-store',
        headers:{'content-type':'application/json'},
        body:JSON.stringify({location,customerId,ticketKey,reservationIds}),
      });
      const body=await response.json() as {ok:boolean;data?:{
        giftDraftId:string;checkoutUrl:string;paymentStatus:string};
        error?:{code:string}};
      if(!response.ok||!body.ok||!body.data||
        body.data.paymentStatus!=='UNPAID_TEST_SESSION'||
        !uuid.test(body.data.giftDraftId))
        throw Error(body.error?.code??'Gift Card TEST payment is unavailable.');
      const url=new URL(body.data.checkoutUrl);
      if(url.protocol!=='https:'||url.hostname!=='checkout.stripe.com')
        throw Error('Invalid Stripe Gift Card checkout destination.');
      setGiftDraftId(body.data.giftDraftId);setStatus('CHECKOUT_OPEN');
      if(tab)tab.location.replace(url.href);
      else window.location.assign(url.href);
    }catch(e){tab?.close();setError(e instanceof Error?e.message:
      'Gift Card TEST checkout unavailable.');}
    finally{setBusy(false);}
  };
  return <div className="ecfs-gift-tender">
    <button type="button" disabled={!eligible||busy||
      status==='ISSUED_PENDING_DELIVERY'} onClick={()=>void checkout()}>
      {busy?'Opening Card Checkout…':'Store Card'}</button>
    {giftDraftId&&<section className="ecfs-cash-tender"
      aria-label="Gift Card payment status">
      <p role="status">{status==='ISSUED_PENDING_DELIVERY'
        ?'Stripe TEST payment verified and Gift Card vouchers issued. Delivery follows the saved Gift Card setup.'
        :status==='PAID_UNFULFILLED'
          ?'Stripe TEST payment verified. Gift Card issuance is processing.'
          :'Checkout opened. No Gift Card has been paid or delivered yet.'}</p>
      <small>Gift checkout: {giftDraftId}</small>
      {status==='ISSUED_PENDING_DELIVERY'&&<button type="button"
        onClick={onComplete}>Close Paid Sale</button>}
    </section>}
    {error&&<small role="alert">{error}</small>}
  </div>;
}
